export default __webpack_public_path__ + "static/media/notification_sound.a4aa05a5.mp3";